<script>
	import { page } from '$app/stores';
	import AlertWarning from '@icons/AlertWarning.svelte';
	import { t } from '$lib/translations';
	import Headline from '@components/Headline.svelte';
	import Icon from '@components/Icon.svelte';
	import { onMount } from 'svelte';
	import { getUserType, setPageView } from '$lib/tracking';
	import BackToOverview from '@components/BackToOverview.svelte';

	onMount(() => {
		setPageView({
			page_type: 'error.common',
			page_category_1: 'event',
			page_category_2: 'event',
			page_category_3: 'event',
			page_product_catalog: 'event',
			page_content_id: `erlebenwasverbindet.telekom.de.privatkunden.fehlerseite-404`,
			shop_customer_type: getUserType(),
			user_type: getUserType(),
			user_login_status: 'not-logged-in'
		});
	});
</script>

<div class="min-h-screen-minus-header-footer flex flex-col items-center justify-center">
	<div class="flex mb-8">
		<Icon class="!w-20 !h-20" component={AlertWarning} />
	</div>
	<Headline size="hero" class="max-w-xl text-center"
		>{$page.status === 404 ? $t(`common.error.404`) : $t(`common.error.generic`)}</Headline
	>
	<BackToOverview noLabel />
</div>

<style>
	.min-h-screen-minus-header-footer {
		min-height: calc(100vh - 3.75rem - 10.9375rem);
	}

	@media (min-width: 1024px) {
		.min-h-screen-minus-header-footer {
			min-height: calc(100vh - 5.25rem - 10.9375rem);
		}
	}

	@media (min-width: 1344px) {
		.min-h-screen-minus-header-footer {
			min-height: calc(100vh - 6rem - 10.9375rem);
		}
	}

	@media (min-width: 1680px) {
		.min-h-screen-minus-header-footer {
			min-height: calc(100vh - 7.5rem - 9.8125rem);
		}
	}
</style>
